'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Credential(id, kind, name, username, hash, inherited, created, expires) {
  this.n1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.j9 = null;
  this.fh = null;
  this.kX = null;
  this.eZ = null;
  this.Kz = false;
  this.Dr = null;
  this.xd = null;
  this.n1 = id;
  this.j9 = kind;
  this.fh = name;
  this.kX = username;
  this.eZ = hash;
  this.Kz = inherited;
  this.Dr = created;
  this.xd = expires;
}
export { $c_Lpresto_types$Credential as $c_Lpresto_types$Credential };
$p = $c_Lpresto_types$Credential.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Credential;
/** @constructor */
function $h_Lpresto_types$Credential() {
}
export { $h_Lpresto_types$Credential as $h_Lpresto_types$Credential };
$h_Lpresto_types$Credential.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("Credential"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.n1;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().br(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.j9));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.fh));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.kX));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.eZ));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.Kz ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.Dr));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.xd));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().al(acc, 8);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$Credential)) {
    if ((this.Kz === x$0.Kz)) {
      var this$1 = this.n1;
      var b = x$0.n1;
      var $x_3 = ((this$1.e === b.e) && (this$1.f === b.f));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x = this.j9;
      var x$2 = x$0.j9;
      var $x_2 = (x === x$2);
    } else {
      var $x_2 = false;
    }
    if (((($x_2 && (this.fh === x$0.fh)) && (this.kX === x$0.kX)) && (this.eZ === x$0.eZ))) {
      var x$3 = this.Dr;
      var x$4 = x$0.Dr;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.xd;
      var x$6 = x$0.xd;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 8;
});
$p.s = (function() {
  return "Credential";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.n1;
      break;
    }
    case 1: {
      return this.j9;
      break;
    }
    case 2: {
      return this.fh;
      break;
    }
    case 3: {
      return this.kX;
      break;
    }
    case 4: {
      return this.eZ;
      break;
    }
    case 5: {
      return this.Kz;
      break;
    }
    case 6: {
      return this.Dr;
      break;
    }
    case 7: {
      return this.xd;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.E = (function() {
  return this.fh;
});
$p.afD = (function() {
  return this.kX;
});
$p.GP = (function() {
  return ("c#" + this.n1);
});
$p.jk = (function() {
  return this.n1;
});
function $isArrayOf_Lpresto_types$Credential(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.js)));
}
export { $isArrayOf_Lpresto_types$Credential as $isArrayOf_Lpresto_types$Credential };
var $d_Lpresto_types$Credential = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Credential, "presto.types$Credential", ({
  js: 1,
  aA: 1,
  ju: 1,
  ee: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$Credential as $d_Lpresto_types$Credential };
//# sourceMappingURL=presto.types$-Credential.js.map
